import Swal from 'sweetalert2/dist/sweetalert2.js';
import Vue from 'vue';

import 'sweetalert2/src/sweetalert2.scss';

const sweetalertPlugin = {
	install() {
		Vue.Swal = Swal;
		Vue.prototype.$Swal = Swal;

		Vue.ToastSwal = Swal.mixin({
			toast: true,
			position: 'top-end',
			showConfirmButton: false,
			timer: 3000,
			customClass: { container: 'fullscreen' }
		});
		Vue.prototype.$ToastSwal = Vue.ToastSwal;

		Vue.DeleteSwal = Swal.mixin({
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, delete it!',
			customClass: { container: 'fullscreen' }
		});
		Vue.prototype.$DeleteSwal = Vue.DeleteSwal;

		Vue.LeavePageSwal = Swal.mixin({
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: "Go ahead. I'm good.",
			customClass: { container: 'fullscreen' }
		});
		Vue.prototype.$LeavePageSwal = Vue.LeavePageSwal;

		Vue.prototype.$ErrorSwal = Vue.ErrorSwal = function (error) {
			Vue.Swal.fire(
				'Oh no!<br>Something went horribly wrong.',
				'Error: ' + error.response.status + ' (' + error.response.statusText + ')',
				'error'
			);
		};

		Vue.prototype.$CustomErrorSwal = Vue.CustomErrorSwal = function (code, status, message) {
			Vue.Swal.fire(
				'Oh no!<br>Something went horribly wrong.',
				'Error  ' +
					code +
					': ' +
					status +
					'<br/><br/><b>' +
					message +
					'</b><br/><br/><small><i>Please get in touch with a nerd<br/>near you immediately!</i></small>',
				'error'
			);
		};
		Vue.prototype.$SuccessSwal = Vue.SuccessSwal = function (message) {
			Vue.ToastSwal.fire('Success!', message, 'success');
		};
		Vue.prototype.$InfoSwal = Vue.InfoSwal = function (message) {
			if (process.env.NODE_ENV !== 'production') {
				Vue.ToastSwal.fire('', message, 'info');
			} else {
				console.log(message);
			}
		};
	}
};

Vue.use(sweetalertPlugin);
